import React from 'react';

import Link from 'ui-kit/link/link';
import muncieMap from 'assets/images/muncie-map.jpeg';

import './style.css';

const Hero = ({ linkTo, linkLabel, imgSrc, size, title, text }) => {
    const resolveHeroBackgroundSize = () => {
        switch (size) {
            case 'small': {
                return '20rem';
            }
            default:
                return '34rem';
        }
    };

    const backgroundStyle = {
        backgroundImage: `url(${imgSrc ?? muncieMap})`,
        backgroundSize: 'cover',
        filter: 'contrast(25%)',
        minHeight: resolveHeroBackgroundSize(size),
        width: '100%'
    };

    return (
        <div className={`hero ${size ?? 'large'}`}>
            <div className="hero-background" style={backgroundStyle} />
            <div className="hero-content">
                <h1 className="hero-title">{title}</h1>
                <div className="hero-text">{text}</div>
                {linkTo && <Link to={linkTo} label={linkLabel} variant="button" />}
            </div>
        </div>
    );
};

export default Hero;
